import { fetchApi } from "../../tools"

const getPedidos = async (props) => {
    
    const { headers, idProveedor, urlInvoiceApi } = props;
    const res = await fetchApi({
        url: urlInvoiceApi + '/utils/busquedas',
        headers,
        content: {
            "opcion": "PEDIDOSPROVEEDORES",
            "IdProveedor": idProveedor
          }
    })
    return res.msg
}

const getRevisionFacturas = async (props) => {
  const { headers, urlInvoiceApi } = props;
  const res = await fetchApi({
    url: urlInvoiceApi + '/utils/busquedas',
    headers,
    content: {
      "opcion": "REVISIONFACTURAS"
    }
  })
  return res.msg
}

const enviar = async (arrEnvios, headers, urlInvoiceApi) => {
  let arr = []
  for await(const element of arrEnvios){
    let res = await fetchApi({
      url: urlInvoiceApi + '/proveedores/envios_proveedores',
      method: 'POST',
      headers:headers,
      content: element
    })
    arr.push(res.msg[0]['Error'])
  }
  return arr
}



export {
    getPedidos,
    enviar,
    getRevisionFacturas,
}